import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { Main, PageHeader, Tabs } from '../../Components'
import { PageSettingsDomains } from './page-settings-domains';
import { PageSettingsGeneral } from './page-settings-general';
import { PageSettingsTheme } from './page-settings-theme';

import './page.settings.css'

export function PageSettings() {

	const { page_id } = useParams();
    const location = useLocation();
  
  
    let path = location.pathname.split('/')    
    const globalParentPathItem = 'settings'
    const lastItem = path[path.length -1];
    let initiaTab = 'general';
     
    if( lastItem === globalParentPathItem) initiaTab = 'general'
    else initiaTab = lastItem
	 

	return (
		<>
		<Helmet>
            <title>{`Page settings - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Status Pages', link: '/pages' },
				{ name: 'Page Settings', link: '' },
			]}
			 >
				<PageHeader
					title="Page Settings"
					description="Customize your page information to match your brand from name to background color."
					/>
				<Tabs initialId={initiaTab}>
					<Tabs.Item id="general" href={`/pages/${page_id}/settings`}>General</Tabs.Item>
					<Tabs.Item id="domains" href={`/pages/${page_id}/settings/domains`}>Domains</Tabs.Item>
					<Tabs.Item id="theme" href={`/pages/${page_id}/settings/theme`}>Theme</Tabs.Item>
				</Tabs>
				{/* ROUTE PREVIEW */}
				<Routes>
					<Route 
						path={`/theme`} 
						element={<PageSettingsTheme />} />
					<Route 
						path={`/domains`} 
						element={<PageSettingsDomains />} />
					<Route 
						path={`/`} 
						element={<PageSettingsGeneral />} />
				</Routes>
		 </Main>
		</>
	)
}
